module.exports = __webpack_public_path__ + "static/media/GunaldiCreateImporter.be6a45ce.svg";